import { Settings2 } from "lucide-react";
import { useCanAccess } from "ra-core";
import { useState } from "react";

import { cn } from "@/lib/utils";

import { buildRequirementsMessage } from "../requirements";
import { useAgents } from "../useAgents";
import { fillReply } from "./quickReplies";
import { QuickRepliesDialog } from "./QuickRepliesDialog";
import { useQuickReplies } from "./useQuickReplies";

interface QuickRepliesPanelProps {
  firstName?: string | null;
  agentFirstName: string;
  onPick: (text: string) => void;
}

/** Saved replies above the composer: one click puts the text in the box. */
export const QuickRepliesPanel = ({
  firstName,
  agentFirstName,
  onPick,
}: QuickRepliesPanelProps) => {
  const { meId } = useAgents();
  const { canAccess: isAdmin = false } = useCanAccess({
    resource: "money",
    action: "list",
  });
  const { replies, refetch } = useQuickReplies();
  const [managing, setManaging] = useState(false);

  const chip =
    "rounded-full border px-2.5 py-1 text-xs hover:bg-muted transition-colors";

  return (
    <div className="flex flex-wrap gap-1.5">
      <button
        type="button"
        className={chip}
        onClick={() =>
          onPick(buildRequirementsMessage(firstName, agentFirstName))
        }
      >
        Pedir requisitos
      </button>
      {replies.map((reply) => (
        <button
          key={reply.id}
          type="button"
          title={reply.owner_id != null ? "Respuesta tuya" : undefined}
          className={cn(
            chip,
            reply.owner_id != null &&
              "border-lime-400 bg-lime-50 dark:bg-lime-950/40",
          )}
          onClick={() =>
            onPick(fillReply(reply.body, firstName, agentFirstName))
          }
        >
          {reply.label}
        </button>
      ))}
      <button
        type="button"
        className={cn(
          chip,
          "inline-flex items-center gap-1 text-muted-foreground",
        )}
        onClick={() => setManaging(true)}
      >
        <Settings2 className="h-3.5 w-3.5" />
        Gestionar
      </button>
      <QuickRepliesDialog
        open={managing}
        onOpenChange={setManaging}
        replies={replies}
        meId={meId}
        isAdmin={isAdmin}
        onSaved={() => refetch()}
      />
    </div>
  );
};
